import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import GeneralUtils from '../../../utils/GeneralUtils';
import { RootState } from '../../store';

export const typologyServiceApi = createApi({
  reducerPath: 'typologyServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: GeneralUtils.getEnvironment(window.location.origin),
    prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).authSlice.accountInformation.token;
        if (token) {
            headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    }
  }),
  endpoints: builder => ({
    getTypologies: builder.mutation<any, any>({
      query: ({locale}) => ({
        url: `/news/category/getAll/?locale=${locale}`,
        method: 'GET',
      }),
      async onQueryStarted(id, {dispatch, queryFulfilled}) {
        try {
          await queryFulfilled;
        } catch  {
        }
      },
    }),
  }),
});

export const {
  useGetTypologiesMutation,
} = typologyServiceApi;